/* eslint-disable no-underscore-dangle */
import React from 'react';
import 'assets/css/reportingPageStyle.css';
import {
  Checkbox, Popover, Icon, Button, Row, Col, Divider, Input, Form,
} from 'antd';
import { SpH5 } from 'components/DesignKit';

class AmountMenu extends React.Component {
  state = {
    icon: {},
    selectedItems: [],
    defaultBackgroundColor: '#fbfbfb',
    minAmount: null,
    maxAmount: null,
  };

  componentDidMount = () => {
    if (this.props.value && this.props.value.length) {
      this.setState(
        {
          selectedItems: [...this.props.value],
        },
        () => this.checkIconFilled(),
      );
    }
  };

  checkIconFilled = () => {
    if (this.state.selectedItems.length) {
      this.setState({ icon: { theme: 'filled' } });
    } else {
      this.setState({ icon: {} });
    }
  };

  changeBackgroundColor = () => {
    if (this.state.defaultBackgroundColor === '#fbfbfb') {
      this.setState({ defaultBackgroundColor: '#e0e0e0' });
    } else {
      this.setState({ defaultBackgroundColor: '#fbfbfb' });
    }
  };

  amountboxRender = () => (
    <Checkbox.Group>
      <Row
        type="flex"
        style={{
          flexDirection: 'column',
          margin: '14px',
        }}
      >
        <Input.Group>
          <Col
            key={`input-group-${1}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'start',
              color: '#808080',
            }}
          >
            <label htmlFor="">Min</label>
            <Form.Item name="length" noStyle>
              <Input
                value={this.state.minAmount}
                placeholder="0.00"
                onChange={(e) => this.setState({ minAmount: e.currentTarget.value })}
                onKeyPress={e => {
                  const keyCode = e.charCode || e.which;
                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col
            key={`input-group-${2}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'start',
              color: '#808080',
            }}
          >
            <label htmlFor="">Max</label>
            <Form.Item name="length" noStyle>
              <Input
                value={this.state.maxAmount}
                placeholder="0.00"
                onChange={(e) => this.setState({ maxAmount: e.currentTarget.value })}
                onKeyPress={e => {
                  const keyCode = e.charCode || e.which;
                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Input.Group>
      </Row>
      {/* <span>&nbsp;</span> */}
      <Divider style={{ margin: '5px 0' }} />
      <span
        style={{
          display: 'block',
          fontSize: '14px',
          cursor: 'pointer',
          fontWeight: 'normal',
          margin: '7px 15px 7px',
          minHeight: '20px',
          color: '#808080',
        }}
        onClick={() => { this.props.searchAll(this.state.minAmount, this.state.maxAmount); }}
      >
        Search
      </span>
      <Divider style={{ margin: '5px 0' }} />
      <span
        style={{
          display: 'block',
          fontSize: '14px',
          cursor: 'pointer',
          fontWeight: 'normal',
          margin: '7px 15px 7px',
          minHeight: '20px',
          color: '#808080',
        }}
        onClick={() => { this.props.clearAll(); this.setState({ minAmount: null }); this.setState({ maxAmount: null }); }}
      >
        Clear all
      </span>
    </Checkbox.Group>
  );

  render() {
    const AmountboxRender = this.amountboxRender;
    return (
      <Popover
        // id="reporting_summary_popover"
        content={<AmountboxRender />}
        trigger="click"
        placement="bottomLeft"
        onVisibleChange={this.changeBackgroundColor}
        overlayStyle={{
          marginTop: '0',
          paddingTop: '0',
        }}
        overlayClassName="reporting_summary_popover"
        // getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <Button
          size="large"
          type="primary"
          style={{
            borderRadius: 0,
            borderWidth: 0,
            backgroundColor: this.state.defaultBackgroundColor,
            color: '#414141',
            height: 'auto',
            minWidth: '100px',
            maxWidth: '150px',
            minHeight: '40px',
            boxShadow: 'none',
          }}
        >
          <SpH5 color="#414141" fontWeight="bold">{this.props.title}</SpH5> <Icon type="caret-down" {...this.state.icon} />
        </Button>
      </Popover>
    );
  }
}
export default AmountMenu;
